import { Suspense } from 'react';

import Button from 'Component/Button';
import { WIDTH_FULL } from 'Component/Button/Button.config';
import {
    AddToCart as SourceAddToCart
} from 'SourceComponent/AddToCart/AddToCart.component';
import { lazyComponentLoader } from 'Util/lazyComponentLoader';

import './AddToCart.style';

export const AddToCartPopUpComponent = lazyComponentLoader(() => import(
    /* webpackMode: "lazy", webpackChunkName: "product" */
    'Component/AddToCartPopUp'
), 2);
/** @namespace Bodypwa/Component/AddToCart/Component */
export class AddToCartComponent extends SourceAddToCart {
    renderPlaceholder() {
        return null;
    }

    render() {
        const {
            addProductToCart,
            isDisabled,
            isAdding,
            porductBeingAdded
        } = this.props;

        return (
            <>
                <Suspense fallback={ this.renderPlaceholder() }>
                    <AddToCartPopUpComponent product={ porductBeingAdded } />
                </Suspense>
                <Button
                  onClick={ addProductToCart }
                  isDisabled={ isDisabled }
                  isLoading={ isAdding }
                  width={ WIDTH_FULL }
                  text={ __('Add to cart') }
                />
            </>
        );
    }
}

export default AddToCartComponent;
